<script lang="ts">
    import { STATUS } from "@/constants/statuses";
    import ReviewsRatingInput from "@apps/reviews/components/ReviewsRatingInput/ReviewsRatingInput.svelte";
    import { REVIEW_TYPE } from "@apps/reviews/constants";
    import FormManager from "@lib/FormManager/FormManager";
    import FormManagerController from "@lib/FormManager/FormManagerController.svelte";
    import FormManagerProvider from "@lib/FormManager/FormManagerProvider.svelte";

    import FormLayoutItem from "@components/FormLayout/FormLayoutItem.svelte";
    import ProductContainer from "@components/ProductContainer.svelte";
    import T from "@components/T.svelte";

    import SingleProduct from "../../widgets/review_form_modal_widget/components/ReviewsFormSteps/RatingStep/SingleProduct/SingleProduct.svelte";
    import SingleProductSkeleton from "../../widgets/review_form_modal_widget/components/ReviewsFormSteps/RatingStep/SingleProduct/SingleProductSkeleton.svelte";
    import { LEAVE_REVIEW_SOURCE } from "../../widgets/review_form_modal_widget/constants";

    export let formManager: FormManager;
    export let productId: number | undefined;
    export let reviewType: REVIEW_TYPE | undefined;
    export let source: LEAVE_REVIEW_SOURCE | undefined;
    export let isRateUnsubmitted = false;

    const handleRate = () => {
        if (isRateUnsubmitted) return;
        formManager.submit();
    };
</script>

<div class="gw-rv-form-rating">
    <div>
        <h4 class="gw-rv-form-rating__title">
            {#if reviewType === REVIEW_TYPE.PRODUCT_REVIEW}
                <T
                    namespace="reviews.ReviewsFormModalWidget"
                    translationKey="rating_step_title_product"
                />
            {:else}
                <T
                    namespace="reviews.ReviewsFormModalWidget"
                    translationKey="rating_step_title_shop"
                />
            {/if}
        </h4>

        <FormManagerProvider {formManager}>
            <div class="gw-rv-form-rating__input-block">
                <FormManagerController name="rating" let:field>
                    <FormLayoutItem
                        errors={field.errors || []}
                        namespace="reviews.ReviewsFormModalWidget"
                    >
                        <div class="gw-rv-form-rating__input-container">
                            <ReviewsRatingInput
                                iconHeight="4em"
                                iconWidth="4em"
                                value={field.value}
                                on:change={(v) => {
                                    field.onChange(v);
                                    handleRate();
                                }}
                            />
                        </div>
                    </FormLayoutItem>
                </FormManagerController>
                <div class="gw-rv-form-rating__input-text-container">
                    <p class="gw-rv-form-rating__input-text">
                        <T
                            namespace="reviews.ReviewsFormModalWidget"
                            translationKey="dislike_it"
                        />
                    </p>
                    <p class="gw-rv-form-rating__input-text">
                        <T
                            namespace="reviews.ReviewsFormModalWidget"
                            translationKey="like_it"
                        />
                    </p>
                </div>
            </div>
        </FormManagerProvider>

        {#if source === LEAVE_REVIEW_SOURCE.LEAVE_REVIEW_PAGE_WIDGET && productId}
            <ProductContainer {productId} let:productInfo let:productStatus>
                <div class="gw-rv-form-rating__product">
                    {#if productStatus === STATUS.LOADING}
                        <SingleProductSkeleton />
                    {:else if productInfo.product && productInfo.productUrl}
                        <SingleProduct
                            product={productInfo.product}
                            productUrl={productInfo.productUrl}
                        />
                    {/if}
                </div>
            </ProductContainer>
        {/if}
    </div>
</div>

<style lang="postcss">
    .gw-rv-form-rating {
        @media screen and (max-width: 600px) {
            width: 100%;
        }
        &__title {
            font-size: 1.8em;
            line-height: 1.2;
            font-weight: 600;
            margin: 0;
            text-align: center;
        }

        &__product {
            margin-top: 6em;
        }

        &__input-block {
            margin-top: 2em;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 2.5em;
        }
        &__input-container {
            display: flex;
            justify-content: center;
        }
        &__input-text-container {
            width: calc(5em * 5);
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            user-select: none;

            @media screen and (max-width: 600px) {
                width: 100%;
            }
        }
        &__input-text {
            color: #667085;
            text-align: center;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 1;
            margin: 0;
            &:first-child {
                padding-left: 1.6em;
            }
            &:last-child {
                padding-right: 1.6em;
            }
        }
    }
</style>
